import React from "react";

type AnyFunction = (...args: any[]) => any;
type WrapperFunction<T extends AnyFunction> = (...args: Parameters<T>) => ReturnType<T>;

export const useEvent = <T extends AnyFunction>(callback: T): WrapperFunction<T> => {
  const ref = React.useRef<AnyFunction | undefined>(callback);

  /**
   * Not passing an dependency array will call this function on every render.
   */
  React.useLayoutEffect(() => {
    ref.current = callback;
  });

  /**
   * Return a memoized callback without any dependencies.
   */
  return React.useCallback((...args) => ref.current?.apply(null, args), []);
};
